module.exports = __webpack_public_path__ + "media/add-ons/expo@2x-d948764c.png";